seedWebApp.controller('PlantsController', ['$scope', '$rootScope', '$window', '$route', 'CompanySettingService',
    function ($scope, $rootScope, $window, $route, CompanySettingService) {

        $rootScope.moduleName = 'Ajustes';
        var tab = $route.current.$$route.tab;
        $scope.items = [];

        CompanySettingService.getPlants().then(function (response) {
            $scope.loading = false;
            $scope.items = response.data;            
        }, function () {
            $scope.loading = false;
        })        
    }]);
